<template>
  <div class="customers">
    <toolbar
      backRoute="/dashboard"
      title="Customers"
      :addButton="true"
      addButtonLabel="Add customer"
      addButtonRoute="/dashboard/customers/new" />

    <d-row class="mt-5">
      <d-col cols="12" class="d-flex">
        <d-input
          v-model="filters.search"
          placeholder="Search customers"
          @keyup.native.enter="saveFilters" />
        <d-button
          theme="primary"
          outline
          class="ml-2"
          @click.prevent="saveFilters">
          Search
        </d-button>
        <d-button
          v-if="filters.search !== ''"
          theme="danger"
          outline
          class="ml-2"
          @click.prevent="resetFilters">
          Reset
        </d-button>
      </d-col>
    </d-row>

    <table class="table table-striped table-bordered table-hover mt-5">
      <thead>
        <tr>
          <sortable-table-heading field="name" view="customers" :column="orderColumn" :direction="orderDirection">Name</sortable-table-heading>
          <sortable-table-heading field="town" view="customers" :column="orderColumn" :direction="orderDirection">Town</sortable-table-heading>
          <sortable-table-heading field="country_id" view="country_id" :column="orderColumn" :direction="orderDirection">Country</sortable-table-heading>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody v-if="!loadError">
        <tr v-if="!allDataLoaded">
          <td
            colspan="6"
            class="text-center">
            Loading customers&hellip;
          </td>
        </tr>
        <tr v-if="allDataLoaded && customers.length === 0">
            <td
              colspan="6"
              class="text-center">
              There are no customers to display&hellip;
            </td>
          </tr>
        <tr
          v-for="(customer, index) of customers"
          :key="'customer-' + index">
          <td class="align-middle">{{ customer.name }}</td>
          <td class="align-middle" style="width: 240px;">{{ customer.town }}</td>
          <td class="align-middle" style="width: 240px;">{{ getCountry(customer.country_id) }}</td>
          <td class="align-middle" style="width: 140px;">
            <d-button
              theme="primary"
              @click.native="$router.push('/dashboard/customers/' + customer.id)"
              class="mr-2"
              title="Edit customer">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeCustomer(customer.id)"
              title="Remove customer">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      An error occurred during data loading. <a href="javascript:window.location.reload();" class="alert-link">Reload the page</a> to try again.
    </d-alert>

    <pagination :meta-data="paginationMetaData" />
  </div>
</template>

<script>
import CommonGetters from './../utils/CommonGetters.js';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import SortableTableHeading from './../components/common/SortableTableHeading.vue';

export default {
  name: 'customers',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    'sortable-table-heading': SortableTableHeading
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedCountries;
    }
  },
  data () {
    return {
      loaded: false,
      customers: null,
      loadError: false,
      removeInProgress: false,
      countries: [],
      loadedCountries: false
    };
  },
  mounted () {
    this.loadFilteredData();
    this.loadAdditionalData();
  },
  methods: {
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/countries/items',
        loadedKey: 'loadedCountries',
        outputKey: 'countries',
        errorKey: 'loadError',
        params: {
          pagination: 0
        }
      });
    },
    removeCustomer (customerID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/customers/delete/',
        id: customerID,
        successTitle: 'Customer removed',
        successText: 'The selected customer has been removed',
        confirmTitle: 'Do you really want to remove this customer?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    getCountry (countryID) {
      return CommonGetters.getCountryById(countryID, this.countries);
    }
  }
};
</script>

<style lang="scss">

</style>
